const getSlider = state => state?.slider?.allSliders;
const getSingleSlider = state => state?.slider?.singleSlider;
const getStatus = state => state?.slider?.status;
const getErrors = state => state?.slider?.error;
const getPagination = state => state?.slider?.pagination;
const getAllSliderQueryParams = state => state?.slider?.queryParams;

export { getSlider, getSingleSlider, getErrors, getStatus, getPagination, getAllSliderQueryParams };
